import { render, staticRenderFns } from "./CauselistItem.vue?vue&type=template&id=491284ca&scoped=true"
import script from "./CauselistItem.vue?vue&type=script&lang=js"
export * from "./CauselistItem.vue?vue&type=script&lang=js"
import style0 from "./CauselistItem.vue?vue&type=style&index=0&id=491284ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491284ca",
  null
  
)

export default component.exports